// Helper to build absolute URLs for files returned by /api/tasks-app/upload
// Upload responses are like "/api/files/foo.pdf" or "/api/uploads/folder/x.png"
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const fileUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/api/')) return `${API_URL}${path}`;
  // Legacy/bare key — assume files folder
  return `${API_URL}/api/files/${path}`;
};
